module.exports = __webpack_public_path__ + "media/audio1.5c8b408e.wav";